import { IWidgetConfiguration } from '../';
import { HorizontalBarChartWidget } from '../horizontalBarChart/horizontalBarChart.widget';
import { Helper } from '../../common/';

export interface IBadActorsWidgetOptions {
    seriesClick?: (d, i) => void;
    state?: ($state:angular.ui.IStateService) => (d, i) => void;
}

export interface IBadActorsWidget {
    readData: (guid?: string) => ng.IPromise<any>;
    options?: IBadActorsWidgetOptions;
    configuration?: any;
    type: string;
    baseType: string;
}

export class BadActorsWidgetBase extends HorizontalBarChartWidget {
    baseType = 'badActors';
    col = 0;
    errorSearch = 'bad';
    guid: string;
    icon = 'fa-bar-chart horizontal-bar-chart-miniature';
    row = 0;
    sizeX = 6;
    sizeY = 18;

    constructor(config?: IWidgetConfiguration) {
        super();
        this.setConfiguration(config);
        this.guid = Helper.getGuid();
    }
}